import { jsx } from 'panel';
export function template() {
  const {
    visibility,
    wrapperStyles
  } = this.state;
  return jsx("div", {
    sel: '.mp-tooltip-wrapper',
    class: {
      'mp-tooltip-hidden': visibility === this.helpers.VISIBILITY_HIDDEN,
      'mp-tooltip-transitioning': visibility === this.helpers.VISIBILITY_TRANSITIONING,
      'mp-tooltip-visible': visibility === this.helpers.VISIBILITY_VISIBLE,
      'mp-tooltip-animated': this.helpers.shouldAnimateTooltip()
    },
    style: Object.assign({
      /*
       * It's necessary to set the width on the wrapper to be max-width so that
       * the .mp-tooltip-main element has enough width available from the parent
       * to grow up to the max-width.
       */
      width: this.attr("max-width") || "auto"
    }, wrapperStyles),
    on: {
      click: this.helpers.stopPropagation,
      mousedown: this.helpers.stopPropagation
    }
  }, jsx("div", {
    sel: '.mp-tooltip-main',
    class: {
      ["mp-tooltip-placement-".concat(this.attr("placement"))]: true,
      ["mp-tooltip-type-".concat(this.attr("type"))]: true
    },
    style: Object.assign({
      'max-width': this.attr("max-width"),

      /* Use `pre-line` so \n will determine line breaks when no max-width is set */
      'white-space': this.attr("max-width") ? "pre-line" : "pre",
      hyphens: this.attr("max-width") ? "auto" : "inherit"
    })
  }, jsx("slot", null)));
}